module.exports = __webpack_public_path__ + "img/c3.67952507.png";